import React from 'react';
import { observer } from 'mobx-react';

// Components
import EditExamDetails from './EditExamDetails';
import EditPermittedItems from './EditPermittedItems';
import EditExamNotes from './EditExamNotes';
import EditProctorSettings from './EditProctorSettings';
import ConfirmExam from './ConfirmExam';

const EditSection = observer(class EditSection extends React.Component {
  constructor() {
    super()
    this.state = {
      virtualCalcAllowed: false
    }
  }
  componentDidMount() {
    // Checks to see if automated or hybrid is an available workflowModule
    if(this.props.proctorGroups){
      const virtualCalcAllowed = this.props.proctorGroups.some(group => {
        return group.workflowModule === 'automated' || group.workflowModule.includes('hybrid')
      })

      this.setState({virtualCalcAllowed})
    }

  }
  render() {
    switch(this.props.step) {
      case 1:
        return <EditExamDetails nextStep={this.props.nextStep} {...this.props} />;

      case 2:
        return <EditPermittedItems nextStep={this.props.nextStep} prevStep={this.props.prevStep} virtualCalcAllowed={this.state.virtualCalcAllowed}{...this.props} />;

      case 3:
        return <EditExamNotes nextStep={this.props.nextStep} prevStep={this.props.prevStep} {...this.props} />;

      case 4:
        return <EditProctorSettings prevStep={this.props.prevStep} {...this.props} />;

      case 5:
        return <ConfirmExam prevStep={this.props.prevStep} {...this.props} />;

      // case 5:
      //   if(!this.props.approval) {
      //     return <ExamAttachments prevStep={this.props.prevStep} complete={this.props.complete} {...this.props} />;
      //   } else {
      //     return <ExamAttachmentsList hideTitle={true} hideDelete={true} prevStep={this.props.prevStep} complete={this.props.complete} {...this.props} />;
      //   }

      default:
        return <EditExamDetails nextStep={this.props.nextStep} {...this.props} />;
    }
  }
})

export default EditSection;



// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/EditSection.js